import styled from '@emotion/styled'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[0]};
  margin: 2rem auto;
  line-height: 1.67;
`
const IndentedText = styled.div`
  max-width: 90%;
  margin: 1rem 0 0 auto;
  position: relative;
  p {
    margin: 1rem 0;
    &:before {
      content: '— ';
      color: ${(props) => props.theme.colors.orange};
      font-weight: 700;
      position: absolute;
      left: -1.2rem;
    }
  }

  a {
    color: ${(props) => props.theme.colors.orange};
  }
`
const Bullets = ({ text }) => {
  return (
    <StyledDiv>
      <IndentedText dangerouslySetInnerHTML={{ __html: text }}></IndentedText>
    </StyledDiv>
  )
}

export default Bullets
